
import { Link } from 'react-router-dom';

import { DollarSign } from 'lucide-react';
import { DefaultTooltip } from 'twyne-new.ui';

import { getInfo, keyOf } from '@Components/Grid/components/Table/formatters';

export default function CostUpdater({ info, asLabel }) {
  const { row } = getInfo(info)
  const targetId = keyOf(info, 'updater')
  const target = asLabel ? <span>Set cost</span> : <DefaultTooltip content='Set cost'><DollarSign size={16} /></DefaultTooltip>

  return <>
    <Link to={`/offer/allocations/${row.id}/cost-updater`} id={targetId}>
      {target}
    </Link>
  </>
}
